import { IConfig } from 'libs/types/site/IClient';

export const currentVersion = 'v2.0.0';

export const LOCAL_STORAGE_AUTH_HEADER_KEY = 'authHeader';
export const LOCAL_STORAGE_LANGUAGE = 'language';

export default {
    ApiBaseUrl: process.env.REACT_APP_API_BASE_URL,
    FacebookAppId: process.env.REACT_APP_FACEBOOK_APP_ID,
    GoogleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    GoogleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
    Environment: process.env.NODE_ENV,
    GoogleCaptchaKey: process.env.REACT_APP_GOOGLE_CAPTCHA_KEY,
    AppleClientId: process.env.REACT_APP_APPLE_CLIENT_ID,
    AppleLoginReturnUri: process.env.REACT_APP_APPLE_LOGIN_RETURN_URI,
    AppleRegisterReturnUri: process.env.REACT_APP_APPLE_REGISTER_RETURN_URI,
    RoutesConfig: process.env.REACT_APP_ROUTES_CONFIG,
    GoogleAnalyticsCode: process.env.REACT_APP_GOOGLE_ANALYTICS_CODE,
    AmplitudeApiKey: process.env.REACT_APP_AMPLITUDE_API_KEY,
    StaticContentUrl: process.env.REACT_APP_STATIC_CONTENT_URL
} as IConfig;

//hardcoded markers on server without user
export const transparentMarkerId = '896b1cd4-1cc9-4d13-9b8f-1d9bcd86bd02';
export const configPublicMarkers: {
    id: string;
    image?: string;
}[] = [
    {
        id: transparentMarkerId,
        image: 'https://dvtqxks0zalev.cloudfront.net/app-static/transparent.png'
    }
];
